import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    collapsableContainer: {
      padding: theme.spacing(2),
      borderLeft: '1px solid',
      borderImage: `linear-gradient(to bottom, transparent 2%, ${theme.palette.primary.main}, transparent 98%) 1 100%`,
    },
    tableHeadContainer: {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    tableRows: {
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
    dividerRow: {
      height: `6px`,
      borderTop: `0px solid ${theme.palette.background.default}`,
      borderBottom: `8px solid ${theme.palette.background.default}`,
    },
  });
});
